'use client';
import { useTranslation } from '@/i18n/client';
import { useState } from 'react';
// 组件
import JDIPrice from '@/components/price/index';
import ServiceDetailDraw from '@/components/product/serviceDetailDraw';
// 图标
import InfoGreyIcon from '@/images/icon/InfoGreyIcon.svg';

import styles from './index.module.scss';

interface OrderServiceAgreementProps {
  serviceData: any;
  mainSkuId: string;
  currencySymbol?: string;
}

const OrderServiceAgreement = ({
  serviceData,
  mainSkuId,
  currencySymbol,
}: OrderServiceAgreementProps) => {
  const { t } = useTranslation();
  const [detailConfig, setDetailConfig] = useState({});

  const goDetail = (e: React.MouseEvent, serviceItemData: any) => {
    e.stopPropagation();
    setDetailConfig({
      isOpen: true,
      serviceItem: {
        name: serviceItemData?.skuName,
        skuId: serviceItemData?.skuId,
      },
    });
  };

  const drawerChange = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    setDetailConfig({
      isOpen: false,
    });
  };

  // 价格楼层展示
  const priceFloorRender = (item: any) => {
    let dom = null;
    const { price, showStyle } = item || {};
    if (price) {
      {
        /* showStyle 展示样式 0-正常价格样式 1-FREE样式（加粗黑色）2-会员价强调色（紫色） */
      }
      if (showStyle === 1) {
        dom = <div className={styles.free}>{price}</div>;
      } else {
        dom = (
          <JDIPrice
            symbol={currencySymbol || ''}
            price={price || ''}
            uiType={2}
            containerStyle={{
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '24px',
              height: '24px',
              color: item.showStyle === 2 ? '#7014CC' : '#1A1A1A',
            }}
          />
        );
      }
    }

    return dom;
  };

  return (
    <div
      className={styles.container}
      onClick={(e: React.MouseEvent) => {
        e?.stopPropagation();
      }}
    >
      <ul>
        {serviceData?.map?.((item: any, index: number) => {
          const { skuName, skuId, price, originPrice, showStyle } = item || {};
          return (
            <li key={index} onClick={(e: React.MouseEvent) => goDetail(e, item)}>
              <div className={styles.serviceItem} key={skuId}>
                <div className={styles.serviceLabelBox}>
                  <div className={styles.serviceContent}>{skuName}</div>
                  <InfoGreyIcon />
                </div>
                {/* 价格 */}
                <div className={styles.servicePriceBox}>
                  {/* 到手价展示 */}
                  {priceFloorRender(item)}
                  {/* 划线价展示 */}
                  {originPrice && (Number(originPrice) > Number(price) || showStyle === 1) && (
                    <div>
                      <JDIPrice
                        symbol={currencySymbol || ''}
                        price={originPrice || ''}
                        uiType={2}
                        containerStyle={{
                          fontWeight: 500,
                          fontSize: '12px',
                          lineHeight: '12px',
                          height: '12px',
                          color: '#888B94',
                        }}
                        lineThrough={true}
                      />
                    </div>
                  )}
                </div>
              </div>
              {index !== serviceData?.length - 1 && <div className={styles.line}></div>}
            </li>
          );
        })}
      </ul>
      <ServiceDetailDraw
        detailConfig={detailConfig}
        drawerChange={drawerChange}
        mainskuid={mainSkuId}
      />
    </div>
  );
};

export default OrderServiceAgreement;
